import { MessageCounts } from 'src/domain/analytics';

export const DEFAULT_MINUTES_PER_MESSAGE = 10;

export const estimatedHours = (
    messages: MessageCounts,
    minutes: number = DEFAULT_MINUTES_PER_MESSAGE,
) => ((messages.organization + messages.relative) * minutes) / 60;

export const parseMinutes = (value: string): number | undefined => {
    if (!value.trim()) return undefined;
    const minutes = Number(value);
    return Number.isFinite(minutes) && minutes >= 0 ? minutes : undefined;
};
